import React from "react";

interface ReportHeaderProps {
  title: string;
  subtitle: string;
}

const ReportHeader: React.FC<ReportHeaderProps> = ({ title, subtitle }) => {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h2 className="text-base font-bold text-gray-800">{title}</h2>
        <p className="text-sm text-gray-500">{subtitle}</p>
      </div>
    </div>
  );
};

export default ReportHeader;
